import * as Backbone from "backbone";
import * as $ from "jquery";
import * as _ from "lodash";
import { BaseModifyModalView, BaseModifyModalViewOptions } from "../_BaseModifyModal";

var template = require('templates/modals/dashboard/modifyTabBody.html');

interface ModifyDashboardTabModalOptions {
    dashboardId: number;
    tabId?: number;
    name?: string;
    order?: number;
    modelId: number | null; // Required but can be null for new tabs
    onSave: (name: string, order?: number) => void;
    // Allow any properties from BaseModifyModalViewOptions to be optional
    [key: string]: any;
}

export class ModifyDashboardTabModal extends BaseModifyModalView {
    options: any; // Use any to avoid type conflicts since constructor uses <any> anyway
    template = _.template(template);

    constructor(options: ModifyDashboardTabModalOptions) {
        super(<any>_.extend({
            tagName: "div",
            events: {
                'shown.bs.modal #modifyTabModal': 'handleModalShown',
                'hidden.bs.modal #modifyTabModal': 'handleModalHidden',
                'click .tab-submit': 'handleSubmitButtonClick',
                'input .tab-name-input': 'handleInputTabName'
            }
        }, options));

        this.modalIdSelector = 'modifyTabModal';
        this.handleInputTabName = _.debounce(this.handleInputTabName, 100);
    }

    render() {
        const name = this.options.name || '';
        const order = this.options.order || 1;

        this.$el.html(this.template({
            tabId: this.options.tabId,
            name: name,
            order: order,
            isNew: !this.options.tabId
        }));

        this.delegateEvents();
        return this;
    }

    show() {
        super.show();
        this.handleAddButtonDisabledState();
    }

    handleModalShown() {
        this.$('.tab-name-input').focus();
    }

    handleInputTabName() {
        this.handleAddButtonDisabledState();
    }

    handleAddButtonDisabledState() {
        const name = String(this.$('.tab-name-input').val()).trim();
        const $submitButton = this.$('.tab-submit');
        
        if (name.length > 0) {
            $submitButton.prop('disabled', false);
        } else {
            $submitButton.prop('disabled', true);
        }
    }

    handleSubmitButtonClick(e: JQuery.Event) {
        e.preventDefault();
        const name = String(this.$('.tab-name-input').val()).trim();
        
        if (name.length === 0) {
            return;
        }

        this.setFormSubmitted();
        
        const order = this.options.order || 1;
        $.when(this.options.onSave(name, order)).done(() => {
            this.hide();
        }).fail((err) => {
            this.setFormError();
            var errorMessage = 'Error saving tab';
            if (err && err.responseJSON && err.responseJSON.message) {
                errorMessage = err.responseJSON.message;
            }
            (<any>$).notify({
                title: 'Error',
                message: errorMessage,
                icon: 'fa fa-exclamation-circle',
            }, {
                animate: {
                    enter: 'animated fadeInUp',
                },
                type: "danger-alt",
                placement: { from: "bottom", align: "center" }
            });
        });
    }
}




// WEBPACK FOOTER //
// ./srv/public/js/views/modals/dashboard/ModifyDashboardTabModal.ts